import {mapActions} from "vuex";

const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';
import store from './store';
import infiniteScroll from 'vue-infinite-scroll';
import Vuelidate from 'vuelidate';
import vSelect from 'vue-select';
import Helpers from './plugins/helpers.js';
import VueRouter from 'vue-router';
import moment from 'moment';
import vuetify from './plugins/vuetify';
import {v4 as uuidv4} from 'uuid';

Vue.use(Helpers)
Vue.use(infiniteScroll);
Vue.use(VueResource);
Vue.use(VueCookies);
Vue.use(Vuelidate);
Vue.component('v-select', vSelect);
Vue.use(VueRouter);

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes: []
})

Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CITY', document.head.querySelector('meta[name="city"]').content);
    next()
})

Vue.prototype.$eventBus = new Vue();

Vue.config.devtools = true;

export default new Vue({
    el: '#app',
    store,
    router,
    vuetify,
    data: {
        menuActive: false
    },
    created() {
        if (!this.$cookies.isKey('identity')) {
            this.$cookies.set("identity", uuidv4(), moment().add(1, 'M').toDate())
        }
    },
    methods: {
        ...mapActions({
            GET_DESIGN_PROJECT: 'GET_DESIGN_PROJECT',
        }),
        openMobileMenu() {
            this.menuActive = !this.menuActive;
            document.body.classList.toggle('_no-scroll');
        },

        getFastBue() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setFastBueStatus', true);
            document.body.classList.add('_no-scroll');
        },
        getDesignProjectModal() {
            this.GET_DESIGN_PROJECT(true);
        },
        addSimpleProduct(id) {
            this.$http.post('/api/cart/simple/' + id).then(res => {
                this.$eventBus.$emit('cart.increase');
            });
        },
        openDirectorForm() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setDirectorFormStatus', true);
            document.body.classList.add('_no-scroll');
        },

        openCallback() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setCallbackStatus', true);
            document.body.classList.add('_no-scroll');
        }
    },
});

document.addEventListener("DOMContentLoaded", function () {
//LazyLoad
    let LazyLoad = require('vanilla-lazyload');
    let lazyLoadInstance = new LazyLoad({
        use_native: true,
        elements_selector: '.lazy'
    });

    if (document.location.pathname === '/krasnoyarsk/catalog/dlya-ulicy/markizy/kassetnye-markizy') {
        let markizIframe = document.querySelector('#markizIframe');
        markizIframe.style.display = 'block';
    }
});

require('./modules/accordion');
require('./modules/sticky');
require('./modules/readmore');
require('./modules/lightbox');
require('./modules/add-to-cart');
require("./modules/smart-modal");
